import AOS from 'aos/dist/aos';

export default {
  init() {
    // JavaScript to be fired on all pages
    AOS.init();

    $('.share-btns a').on('click', function (e) {
      e.preventDefault();
      window.open($(this).attr('data-href'), '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    });

    $('.apply-button').click(function() {
      
      $('.details').removeClass('active');
      $('.app').addClass('active');
      $('html,body').animate({scrollTop: 0}, 300);


  });

  
   
    // video
    $(document).on('click','.videoPoster',function(ev) {
      $(this).addClass('d-none');
      ev.preventDefault();
      var $poster = $(this);
      var $wrapper = $poster.closest('.videoWrapper');
      videoPlay($wrapper);
    });
    function videoPlay($wrapper) {
      var $iframe = $wrapper.find('iframe');
      var src = $iframe.data('src');
      // hide poster
      $wrapper.addClass('videoWrapperActive');
      // add iframe src in, starting the video
      $iframe.attr('src',src);
    }
    $('#slider_top').lightSlider({
      item: 1,
      auto: true,
      loop: true,
      speed: 800,
      pause: 6000,
      slideMargin: 0,
      enableDrag: false,
      slideEndAnimation: true,
      nextHtml: '<span><i class="fa fa-angle-right"></i></span>',
      prevHtml: '<span><i class="fa fa-angle-left"></i></span>',
      currentPagerPosition: 'left',
      onSliderLoad: function () {
        $('.lightSlider').removeClass('cS-hidden');
      },
      responsive: [{
          breakpoint: 800,
          settings: {
            item: 2,
            slideMove: 1,
            slideMargin: 6,
          },
        },
        {
          breakpoint: 480,
          settings: {
            item: 1,
            slideMove: 1,
          },
        },
      ],
    });
    $('input[name="sector_id"]').click(function () {
      $(this).tab('show');
  });  
    $('.btn-search').click(function(){
      $('.input').toggleClass('active').focus;
      $(this).toggleClass('animate');
      $('.input').val('');
    });

    $('input[name="year"]').click(function(){
      $('button').removeClass('d-none');
      $('button').fadeIn();
    });
    // get date
    jQuery(function($) {
      $('#getDate').submit(function(e){ 
        e.preventDefault();
        var home = '/';
        var year = $('input[name="year"]:checked').val();
        var month =  $('input[name="month"]:checked').val();
        var day =  $('input[name="day"]:checked').val();
      
        if (year && month == null && day == null ) {
          window.location.href = home + year 
        } else if (year && month && day == null ) {
          window.location.href = home + year + '/' + month;
        } else
         {
          window.location.href = home + year + '/' + month + '/' + day;
         }        
      });
    });
    
    // Inline popups
    $('.inline-popups').magnificPopup({
      delegate: 'a',
      removalDelay: 500, //delay removal by X to allow out-animation
      midClick: 'true',
    });
    // stop enter autocomplete input 
    $('#autocomplete').keydown(function (e) {
      if (e.keyCode == 13) {
          e.preventDefault();
          return false;
      }
  });      
    // rotate image
    $(window).scroll(function () {
      var scroll = $(window).scrollTop() / 100 % Math.PI;
      $('.image-rotate').css({
        transform: 'rotate(' + scroll + 'rad)'});
    });
    // back to top when scroll
    $('#back-top').hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 60) {
        $('#back-top').fadeIn();
      } else {
        $('#back-top').fadeOut();
      }
    });
    $('#back-top').click(function () {
      $('html,body').animate({scrollTop: 0}, 500);
      return false;
    });
    // popup image 
    $('#popup-images').lightGallery({
      mode: 'lg-fade',
      counter: false,
      controls: false,
      download: false,
      autoplay: false,
      share: false,
      thumbnail: false,
      actualSize: false,
      progressBar: false,
      closable: true,
      fullScreen: false,
    });
  // show deropdown when hover 
  $('.banner ul li.dropdown').hover(function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
  }, function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
  });
  // hide last item in span
   $('span.comme:last-of-type').hide();
    // nav services archive and scroll sections
    if ($('.dotnav li a').length != 0) {
      $(window).scroll(function () {
        var scrollPos = $(document).scrollTop() + 400;
        $('.dotnav li a').each(function () {
          var currLink = $(this);
          var refElement = $(currLink.attr('href'));
          if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
            $('.dotnav li a').removeClass('active');
            currLink.addClass('active');
          } else {
            currLink.removeClass('active');
          }
        });
      });

      $('.dotnav a[href*=#]:not([href=#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 500);
            return false;
          }
        }
      });
    }

  

    // slider single 
    jQuery(function ($) {
      $('#FeaturedImage').slick({
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
      });
    });

    $('.modal').on('shown.bs.modal', function () {
      $('html').addClass('modal-open');
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('html').removeClass('modal-open');
    });

  },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/common.js